module.exports = new __parcel__URL__("brave.fcb69d8b.svg").toString();